import React from "react";

export default ({className}) => (
    <svg className={className} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="535.5px" height="535.5px" viewBox="0 0 535.5 535.5" xmlSpace="preserve"
    >
        <g>
            <polygon points="0,497.25 535.5,267.75 0,38.25 0,216.75 382.5,267.75 0,318.75"/>
        </g>
    </svg>

)
